import { render, staticRenderFns } from "./my-trainings.vue?vue&type=template&id=f3c0e606&"
import script from "./my-trainings.vue?vue&type=script&lang=js&"
export * from "./my-trainings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports